/**
 * Valida si un objeto tiene propiedades indefinidas, nulas o vacias 
 * @param {object} objeto a validar
 * @returns {boolean}
 */
export function tienePropVacia(obj) {
   for (var key in obj) {
      if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
         return true;
      }
   }
   return false;
}
/**
 * Verifica si el objeto es indefinido o nulo
 * @param {object} obj 
 * @returns {boolean} devuelve __true__ si es nulo o indefinido y __false__ si es valido
 */
export function esVarNullUndef(obj) {
   return obj === undefined || obj === null;
}
/**
 * Verifica que el objeto no este vacio
 * @param {object} obj 
 * @returns {boolean}
 */
export function objetoNoVacio(obj) {
   return obj && Object.keys(obj).length > 0;
}
/**
 * Verifica si el nro de Ruc es valido 
 * @param {string} ruc 
 * @returns {boolean}
 */
export function esRucValido(ruc) {
   ruc = ruc.replace(' ', '');
   if (ruc.length === 11) {
      var factores = new String('5432765432');
      var ultimoIndex = ruc.length - 1;
      var sumaTotal = 0,
         residuo = 0,
         resultado = 0;
      var ultimoDigitoRUC = 0,
         ultimoDigitoCalc = 0;

      for (var i = 0; i < ultimoIndex; i++) {
         sumaTotal += parseInt(ruc.charAt(i)) * parseInt(factores.charAt(i));
      }
      residuo = sumaTotal % 11;
      resultado = 11 - residuo;

      ultimoDigitoCalc = resultado === 10 ? 0 : resultado === 11 ? 1 : resultado;
      ultimoDigitoRUC = parseInt(ruc.charAt(ultimoIndex));

      return ultimoDigitoRUC === ultimoDigitoCalc;
   } else {
      return false;
   }
}
/**
 * Verifica si la longitud de la cadena con la longitud de numero son iguales
 * @param {string} campo 
 * @param {number} len 
 * @returns {boolean} devuelve __true__ si es la longitud correcta y __false__ si la longitud no es la misma que el de la cadena 
 */
export function esLongitudCorrecta(campo, len) {
   if (campo !== null && !esVarNullUndef(campo.length)) {
      return campo.length === len;
   } else {
      return false;
   }
}
/**
 * Valida si un correo es valido, si tiene el '@' y si tiene la extencion de la organizacion 
 * @param {string} correo 
 * @returns {boolean}
 */
export function esCorreoValido(correo) {
   const result = correo.match(
      /\b(^(\S+@).+((\.gob)|(\.com)|(\.net)|(\.edu)|(\.mi l)|(\.gov)|(\.biz)|(\.org)|(\..{2,2}))$)\b/gi
   );
   return result !== null;
}
/**
 * Verifica si la tecla es un numero 
 * @param {string|number} e 
 * @returns {boolean}
 */
export function esTeclaNumero(e) {
   var valid = '0123456789';
   var key = String.fromCharCode(e.keyCode);
   if (valid.indexOf('' + key) === '-1') {
      return false;
   }
   return true;
}

/**
 * Detemina si el valor es un objeto
 *
 * @param {object} value
 */
export function esObjeto(value) {
   return value !== null && typeof value === 'object';
}

/**
 * Detemina si el valor es una funcion
 *
 * @param {object} value
 */
export function esFuncion(value) {
   return value !== null && value instanceof Function;
}

/**
 * Retorna true si value es RegExp(expresion regular).
 *
 * @param {RegExp} value
 */
export function esRegExp(value) {
   return value instanceof RegExp;
}
/**
 * Verifica si la cadena contiene decimaes
 * @param {number} cadena 
 * @param {number} cifrasEnteras 
 * @param {number} cifrasDecimales 
 * @returns {boolean}
 */
export function esCadenaDecimal(cadena, cifrasEnteras, cifrasDecimales) {
   return (
      cadena.match(new RegExp(`(^\\d{0,${cifrasEnteras}})+(\\.\\d{0,${cifrasDecimales}})?$`)) !==
      null
   );
}
/**
 * Valida si la cadena contine decimal
 * @param {number} cifrasEnteras 
 * @param {number} cifrasDecimales 
 * @returns {boolean}
 */
export function validadorCadenaDecimal(cifrasEnteras, cifrasDecimales) {
   const regex = new RegExp(`(^\\d{0,${cifrasEnteras}})+(\\.\\d{0,${cifrasDecimales}})?$`);
   return function (pCadena) {
      return regex.test(pCadena);
   };
}
